module.exports = __webpack_public_path__ + "img/灵寿石材.b180d114.jpg";